/* eslint-disable react/prop-types */
import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import './UserList.scss';
import ItemList from '../../../common/components/ItemList/ItemList';
import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';
import PropTypes from 'prop-types';
import icSearch from '../../../images/ic_search.png';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import {useHistory} from 'react-router-dom';
import actions from '../../../redux/actions';
import Modal from '../../../common/components/Modal/Modal';
import _ from 'lodash';
import Loading from '../../../common/components/Loading/Loading';
import Chip from '../../../common/components/Chip/Chip';
import {useAuth} from '../../../hooks/useAuth';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const UserList = (props) => {
    const {
        name,
        columnData,
        title,
        getProviders,
        getProvidersMe,
        providers,
        providerListConfig,
        setListConfig,
        deleteProvider,
        resetPassEmail,
        userInfo,
        switchOfUser,
        getProvidersState,
        cleanBranches,
        cleanProvidersBranches,
        cleanListConfig,
        cleanBulkInsert,
        showSidebar,
    } = props;

    const [columnName, setColumnName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [search, setSearch] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [currentPage, setCurrentPage] = useState(-1);
    const [modalText, setModalText] = useState('');
    const [modalButtonAction, setModalButtonAction] = useState(null);

    const {isAdmin} = useAuth();

    const history = useHistory();

    const pageQuantity = Math.ceil(providers?.total/providerListConfig.size);

    const pushPage = (name) => {
        history.push(name);
    };

    const isInitialMount = useRef(true);

    const getProvidersByRole = ()=>{
        if (userInfo.role.name === 'PROVIDER_ADMIN') {
            getProvidersMe();
        } else {
            getProviders();
        }
    };

    useEffect(() => {
        switchOfUser('Usuarios de Prestadores');
        cleanListConfig('providerListConfig');
        setCurrentPage( 1 );
        cleanBranches();
        cleanProvidersBranches();
        cleanBulkInsert();
        // eslint-disable-next-line
    }, []);

    useEffect(()=> {
        if ( !isInitialMount.current || providerListConfig === undefined ) {
            setListConfig( {
                list: 'providerListConfig',
                config: {page: currentPage},
            } );
            getProvidersByRole();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect( ()=>{
        if ( currentPage > pageQuantity ) setCurrentPage( pageQuantity );
        // eslint-disable-next-line
    }, [providers] );

    const sortList = (param)=>{
        const element = providerListConfig?.orderBy?.find((e) => e?.param === param);
        const newElement = {
            param,
            ord: element?.ord === 'asc' ? 'desc' : 'asc',
        };
        const orderBy = [newElement, ...providerListConfig?.orderBy?.filter((e) => e !== element)];

        setListConfig( {
            list: 'providerListConfig',
            config: {orderBy},
        } );

        getProvidersByRole();
    };

    useEffect(() => {
        setColumnName(columnData);
    }, [columnData]);

    const handleDelete = (provider) => {
        setModalButtonAction(() => () => handleClickDelete(provider));
        setModalText('¿SEGURO QUE DESEA ELIMINAR ESTE PRESTADOR?');
        setShowModal(true);
    };

    const handleResetPass = (provider) => {
        setModalButtonAction(() => () => handleClickResetPass(provider));
        setModalText('¿SEGURO QUE DESEA RESTABLECER LA CONTRASEÑA DE ESTE PRESTADOR?');
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleClickDelete = (provider) => {
        deleteProvider(provider.id, provider.user.role.name === 'PROVIDER_USER' ? 'user' : 'admin');
        handleClose();
    };

    const handleClickResetPass = (provider) => {
        resetPassEmail( {email: provider.user.email} );
        handleClose();
    };

    const handleSearch = () => {
        const searchTags={...providerListConfig.searchTags, [searchTag||'name']: search};

        setListConfig( {
            list: 'providerListConfig',
            config: {search: search, searchTags},
        } );
        getProvidersByRole();

        setSearch('');
    };

    const deleteSearchTag = ( tag ) => {
        const searchTags= _.omit( providerListConfig?.searchTags, [tag] );

        setListConfig( {
            list: 'providerListConfig',
            config: {search: search, searchTags},
        } );
        getProvidersByRole();
    };

    const tagNames = {
        name: 'Nombre',
        email: 'Email',
        salesforceProviderName: 'Prestador',
        salesforceBranchName: 'Sede',
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className={'ul-div-header-container'}>
                        <Ebutton classNameButton="ul-btn" onClick={()=>pushPage('add')} text="NUEVO" />
                        <Ebutton classNameButton="ul-btn" onClick={()=>pushPage('bulkInsert')} text="CARGA MASIVA" />
                        <hr className={'ul-hr'}/>
                        <form onSubmit={(event)=>{
                            event.preventDefault();
                            handleSearch();
                        }} >
                        <div className="ul-div-serchCont">
                            <div className="ul-div-tagSel">
                                <select
                                    className="ul-div-searchbar"
                                    onChange={(e) => setSearchTag(e.target.value)}
                                    defaultValue={'name'}
                                >
                                    <option value={'name'} selected="selected" >{tagNames['name']}</option>
                                    <option value={'email'} >{tagNames['email']}</option>
                                    <option value={'salesforceProviderName'} >{tagNames['salesforceProviderName']}</option>
                                    <option value={'salesforceBranchName'} >{tagNames['salesforceBranchName']}</option>
                                </select>
                            </div>
                            <div className="ul-div-searchbar">
                                <input
                                    placeholder="Buscar prestador"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value.replace(/[^\w\s.\@\_\+]/gi, ''))}
                                />
                                <button type='submit'><img src={icSearch} alt={'search'}/></button>

                            </div>
                        </div>
                        </form>
                    </div>
                </div>
                <div>
                { providerListConfig?.searchTags && Object.keys(providerListConfig?.searchTags).map( (key)=>
                    <Chip
                        key={key}
                        text={tagNames[key]+': '+providerListConfig?.searchTags[key]}
                        event={ ()=>{
                            deleteSearchTag(key);
                        } }
                    />,
                )
                }
                </div>

                <div className="ul-div-sect-table">
                    { getProvidersState.success?
                        <table className="ul-div-table">
                            <ItemList type="lender-header" data={columnName} sortList={sortList} sortParam={providerListConfig.orderBy}/>
                            <tbody>
                            {
                                providers?.results?.length <= 0 ?
                                    <tr><td colSpan={100} ><CustomAlert text='prestadores' /></td></tr> :
                                    providers?.result && providers.result.map((item, index) => (
                                        <ItemList
                                        key={item.id}
                                        type="lender-data"
                                        data={item}
                                        handleDelete={handleDelete}
                                        handleResetPass={handleResetPass}
                                        isAdmin={isAdmin}
                                        />
                                    ))
                            }
                            </tbody>
                        </table> :
                    getProvidersState.loading?<Loading className="ul-div-sect-table" />:
                        <CustomAlert text={'prestadores' || String(getProvidersState.error)} severity='error' />
                    }
                </div>

                <div className="ul-div-bottom">
                    <ListPaginator
                        pageQuantity={pageQuantity}
                        currentPage={providerListConfig.page}
                        setCurrentPage={setCurrentPage}
                        initInOne={true}
                    />
                </div>
            </div>
            {showModal && (
                <Modal
                    showModal={showModal}
                    handleClose={handleClose}
                    handleClick={modalButtonAction}
                    modalText={modalText}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    columnData: state.home.columnData,
    title: state.home.title,
    providers: state.home.providers,
    userInfo: state.login.userInfo,
    providerListConfig: state.home.providerListConfig,
    getProvidersState: state.home.getProvidersState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getProviders: () => dispatch(actions.home.getProvidersRequest()),
    getProvidersMe: () => dispatch(actions.home.getProvidersMeRequest()),
    deleteProvider: (id, providerType) => dispatch(actions.home.deleteProviderRequest(id, providerType)),
    setListConfig: (body) => dispatch( actions.home.setListConfig(body) ),
    resetPassEmail: (body) => dispatch(actions.login.resetPassEmailRequest(body)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
    cleanBulkInsert: () => dispatch(actions.home.cleanBulkInsert()),
});

UserList.propTypes = {
    name: PropTypes.string,
    columnData: PropTypes.object,
    title: PropTypes.string,
    getProviders: PropTypes.func,
    getProvidersMe: PropTypes.func,
    deleteProvider: PropTypes.func,
    userInfo: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserList);

